// src/context/StoreContext.jsx
import PropTypes from "prop-types";
import { createContext, useState } from "react";
import { toast } from "react-toastify";

export const StoreContext = createContext(null);

const StoreContextProvider = ({ children }) => {
  const [cartData, setCartData] = useState([]);

  const [frete, setFrete] = useState(0);

  console.log(cartData);

  const addToCart = (item) => {
    toast(item.titulo + " adicionado ao carrinho!");
    setCartData((prevCart) => {
      const existingItem = prevCart.find((cartItem) => cartItem.id === item.id);

      if (existingItem) {
        return prevCart.map((cartItem) =>
          cartItem.id === item.id
            ? { ...cartItem, quantidade: cartItem.quantidade + 1 }
            : cartItem
        );
      } else {
        return [...prevCart, { ...item, quantidade: 1 }];
      }
    });
  };
  const decrementCartItem = (cartItemId) => {
    setCartData((prevCart) =>
      prevCart
        .map((cartItem) =>
          cartItem.id === cartItemId
            ? { ...cartItem, quantidade: cartItem.quantidade - 1 }
            : cartItem
        )
        .filter((cartItem) => cartItem.quantidade > 0)
    );
  };

  const removeCartItem = (cartItemId) => {
    setCartData((prevCart) =>
      prevCart.filter((cartItem) => cartItem.id !== cartItemId)
    );
  };

  const contextValue = {
    cartData,
    addToCart,
    decrementCartItem,
    removeCartItem,
    frete,
    setFrete,
  };

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

StoreContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StoreContextProvider;
